<form (ngSubmit)="submit(true)" [formGroup]="form" class="flex flex-col gap-4">
  <h3>Alta de grupo</h3>

  <div class="rounded-full aspect-square border-1 h-[4rem] w-[4rem] flex items-center justify-center shadow-e1"
       style="border-color: var(--color-neutral-300)">
    <img alt="Icon" class="h-[3rem]" src="/assets/icons/compliance/favorite.png">
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="name">Nombre del grupo de trabajo</label>
    <div class="input-icon">
      <input autocomplete="off" formControlName="name" id="name" placeholder="Por ejemplo: Equipo jurídico" type="text">
    </div>
    @if (form.get('name')?.touched && form.get('name')?.invalid) {
      <span class="cd-text-b4 text-error-600">El nombre del grupo es obligatorio.</span>
    }
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="description">Descripción</label>
    <div class="input-icon">
      <input autocomplete="off" formControlName="description" id="description" placeholder="Describe brevemente el objetivo del grupo" type="text">
    </div>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="role">Encargado</label>
    @if (isLoadingEmployees) {
      <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
    } @else {
      <core-select
        [options]="employeeOptions"
        formControlName="managerId"
        placeholder="Selecciona encargado"/>
    }
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="role">Agregar empleado</label>
    @if (isLoadingEmployees) {
      <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
    } @else {
      <core-select
        [options]="employeeOptions"
        formControlName="employeeId"
        placeholder="Selecciona empleado"/>
    }
    <button (click)="addSelectedEmployee()" class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem] mt-2"
            [disabled]="isLoadingEmployees || isSubmitting"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem" type="button">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/plus-square.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">Agregar</span>
    </button>
  </div>

  <div class="flex flex-col gap-4">

    <div class="cd-text-b2 text-neutral-900 border-b-1 pb-2 mb-4">Lista de empleados</div>

    @for (employee of selectedEmployees; track employee.id) {
      <div class="flex flex-row items-center w-full gap-4">
        <span class="cd-text-b3">{{ employee.name }}</span>
        <span class="ml-auto cd-text-b3">{{ form.get('managerId')?.value === employee.id ? 'Encargado' : 'Empleado' }}</span>
        <button (click)="removeSelectedEmployee(employee)" [disabled]="isSubmitting" class="btn btn-neutral-text !px-1 !py-1" type="button">
          <img alt="Close" class="h-[1rem]" src="/assets/icons/feather/x.svg">
        </button>
      </div>
    } @empty {
      <span class="cd-text-b4 text-neutral-500">Sin empleados agregados.</span>
    }

  </div>

  @if (errorMessage) {
    <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
  }

  <div class="w-full flex flex-row items-center gap-4 mt-4">
    <button [disabled]="isSubmitting" class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem" type="submit">
      <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/save.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">
        {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
      </span>
    </button>

    <button (click)="submit(false)" [disabled]="isSubmitting" class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem" type="button">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/plus-square.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">Guardar y crear otro</span>
    </button>
  </div>
</form>
